import {HasEmojis, Tone} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';

export interface AiTextReWriteOptionProps {
  id?: string;
  showNewTag?: boolean;
  promptFilter?: AiTextReWritePromptFilter[];
}

export enum AiTextReWritePromptFilterId {
  TONE = 'TONE',
  EMOJI = 'EMOJI',
}

export interface AiTextReWritePromptSubFilter {
  name: string;
  id: AiTextReWritePromptSubFilterId;
}

export interface AiTextReWritePromptFilter {
  id: AiTextReWritePromptFilterId;
  name: string;
  subfilters: AiTextReWritePromptSubFilter[];
}

const TONE_SUBFILTERS: AiTextReWritePromptSubFilter[] = [
  {id: Tone.NEUTRAL, name: 'Neutral'},
  {id: Tone.PROFESSIONAL, name: 'Professional'},
  {id: Tone.EXCITED, name: 'Excited'},
  {id: Tone.CONFIDENT, name: 'Confident'},
  {id: Tone.WITTY, name: 'Witty'},
  {id: Tone.EMPOWERING, name: 'Empowering'},
  {id: Tone.FUNNY, name: 'Funny'},
];

const EMOJI_SUBFILTERS: AiTextReWritePromptSubFilter[] = [
  {id: HasEmojis.Enabled, name: 'Use Emojis'},
  {id: HasEmojis.Disabled, name: 'No Emojis'},
];

export const AI_TEXT_RE_WRITE_PROMPT_FILTERS: AiTextReWritePromptFilter[] = [{id: AiTextReWritePromptFilterId.TONE, name: 'Tone', subfilters: TONE_SUBFILTERS}];

export type AiTextReWritePromptSubFilterId = Tone | HasEmojis;

export interface SelectedPromptFilter {
  filterId: AiTextReWritePromptFilterId;
  subFilterId: AiTextReWritePromptSubFilterId;
}

export interface ImageMorphRequestItem {
  hashedFilename: string;
  url: string;
}
